import React from 'react'
import {useDispatch, useSelector} from "react-redux"

const AppFooter = () => {
  const sideNavBarOnOff = useSelector(state => state.sidebarShow.sideNavBarOnOff)
  return (
    <div className='footer-wrap'>
      <section className="ban">
        <div className="container">
            <a href="https://www.mohw.go.kr/react/index.jsp" target="_blank"><img src="/images/ban01.png" alt="보건복지부" /></a>
            <a href="https://www.khidi.or.kr/kps" target="_blank"><img src="/images/ban02.png" alt="한국보건산업진흥원" /></a>
            <a href="https://www.catholic.ac.kr/index.do" target="_blank"><img src="/images/ban03.png" alt="가톡릭대학교" /></a>
        </div>
      </section>
      <footer className="footer">
        <div className="container">
          Copyright ⓒ 2021 CODiPAI. All rights reserved.
        </div>
      </footer>
    </div>
  )
}

export default React.memo(AppFooter)
